import { render, staticRenderFns } from "./equimpment-detail.vue?vue&type=template&id=5b33e540&scoped=true"
import script from "./equimpment-detail.vue?vue&type=script&lang=js"
export * from "./equimpment-detail.vue?vue&type=script&lang=js"
import style0 from "./equimpment-detail.vue?vue&type=style&index=0&id=5b33e540&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33e540",
  null
  
)

export default component.exports